import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import api from "../services/api";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png", iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png", shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png" });

export default function Carte() {
  const [supports, setSupports] = useState([]);
  useEffect(() => { api.get("/rapports/carte").then(r => setSupports(r.data)).catch(() => {}); }, []);

  return (
    <div style={{ padding: 32 }}>
      <h1 style={{ fontSize: 24, fontWeight: 800, color: "#1B3A8C", marginBottom: 24 }}>Cartographie des supports</h1>
      <div style={{ borderRadius: 12, overflow: "hidden", boxShadow: "0 2px 12px rgba(0,0,0,0.1)", height: "calc(100vh - 160px)" }}>
        <MapContainer center={[9.5370, -13.6773]} zoom={12} style={{ height: "100%", width: "100%" }}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" />
          {supports.filter(s => s.latitude && s.longitude).map(s => (
            <Marker key={s.id} position={[s.latitude, s.longitude]}>
              <Popup>
                <div style={{ minWidth: 180 }}>
                  <strong style={{ color: "#1B3A8C" }}>{s.nom}</strong><br />
                  <span style={{ fontSize: 12, color: "#666" }}>Code: {s.code}</span><br />
                  <span style={{ fontSize: 12 }}>Statut: <b>{s.statut}</b></span><br />
                  {s.adresse && <span style={{ fontSize: 12, color: "#888" }}>{s.adresse}</span>}
                </div>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
      <div style={{ marginTop: 12, color: "#888", fontSize: 13 }}>{supports.filter(s=>s.latitude).length} supports géolocalisés sur {supports.length} total</div>
    </div>
  );
}
